import { useEffect, useState, useRef } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./../../Calendar/Calendar.css"
import { format } from 'date-fns';
import './NewTabletBookingForm.css';
import { ErrorAlert } from '../../crud/utils';
import useApp from '../../AppContext';
import { loadListAllObjects, loadFormObject, postBooking, loadDataObject, loadEditObject, getBookingSuppliers, getPorders, getBookingTasks, getDropdownLookupList } from "../../Calendar/CalendarUtils";
import { getPropValue, setPropValue, createGql, callApi } from '../../crud/utils';
import TabletSuccMessage from "../Components/TabletSuccMessage";
import PhotoUpload from "../Components/PhotoUpload";
import AutoCompleteOneOutPut from "../../crud/AutoCompleteOneOutPut";
import PaginationControls from "../../Components/PaginationControls";
import Loading from "../../Loading";
import WarningIcon from '@mui/icons-material/Warning';
import { t } from "./../../i18n"
import CustomDropdown from "../../Components/CustomDropdown";

function EditBookingForm(props) {
    const app = useApp();
    const handleSaveBookingRef = useRef(null);

    useEffect(() => {
        if (props.saveTriggered > 0) {
            handleSaveBookingRef.current?.();
        }
    }, [props.saveTriggered]);
    const [gridTop] = useState(app.gridTop);
    const [serverUrl] = useState(app.serverUrl);
    const [userid] = useState(app.sessionToken?.UserId);
    const [language] = useState(app.sessionToken?.Language);
    const [allColumnsObj, setAllColumnsObj] = useState({});
    const [bookingObj, setBookingObj] = useState({})
    const [isLoadObj, setIsLoadObj] = useState(false);
    const [lookUpInfo, setLookUpInfo] = useState(null);
    const [titleValue] = useState("Το όχημα εξήλθε με επιτυχία");
    const [btnSuccessScreenValue] = useState("Επόμενη έξοδος");
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(null);
    const [, setUploadedImages] = useState([]);
    const [showTasks, setShowTasks] = useState(false);
    const [licenseNo, setLicenseNo] = useState([]);
    const [showMatchingDropdown, setShowMatchingDropdown] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [bookingId, setBookingId] = useState(null);
    const [actions, setActions] = useState(null);
    const [disabledFieldsFlg, setDisabledFieldsFlg] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [showNoResultsMessage, setShowNoResultsMessage] = useState(false);
    const [warningMessage, setWarningMessage] = useState(null);
    const itemsPerPage = 3;
    const photoUploadRef = useRef(null);

    const { onValidationChange } = props;
    useEffect(() => {
        const isValid = actions === "EditBoocking" && bookingId !== null;
        onValidationChange?.(isValid);
    }, [actions, bookingId, onValidationChange]);

    const totalPages = Math.ceil(licenseNo.length / itemsPerPage);
    const paginationLicenseNo = licenseNo.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    useEffect(() => {
        setCurrentPage(1);
    }, [licenseNo]);

    useEffect(() => {
        if (bookingObj?.Yms_BookingTasks && bookingObj?.Yms_BookingTasks?.length > 0) {
            const allTasksCompleted = bookingObj.Yms_BookingTasks.every(task => task.Status >= 3);
            if (!allTasksCompleted) {
                setWarningMessage(t("exitBooking.pendingBookingWarning", language));
            } else {
                setWarningMessage(null);
            }
        } else if (bookingObj?.Obj && bookingObj?.Obj?.Status < 7) {
            setWarningMessage(t("exitBooking.pendingBookingWarning", language));
        } else {
            setWarningMessage(null);
        }
    }, [bookingObj, language]);

    const handleImagesChange = (url) => {
        setUploadedImages(url);
    };
    useEffect(() => {
        async function getDefaultLayouts() {
            if (!serverUrl) return;
            setIsLoading(true);
            try {
                if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) {
                    let allobj = await loadListAllObjects(serverUrl, props.userToken)
                    if (allobj) {
                        setAllColumnsObj(allobj);
                        setIsLoadObj(true);
                    }
                    const layoutBooking = await loadFormObject(serverUrl, props.userToken, "Yms_Booking");
                    if (layoutBooking) {
                        const retLookupList = await getDropdownLookupList(serverUrl, props.userToken, layoutBooking);
                        if (retLookupList) {
                            setLookUpInfo(prev => {
                                prev = { ...prev };
                                prev["Yms_Booking"] = retLookupList;
                                return prev;
                            });
                        }
                    }
                    const layoutBookTasks = await loadFormObject(serverUrl, props.userToken, "Yms_BookingTasks");
                    if (layoutBookTasks) {
                        const retLookupList = await getDropdownLookupList(serverUrl, props.userToken, layoutBookTasks);
                        if (retLookupList) {
                            setLookUpInfo(prev => {
                                prev = { ...prev };
                                prev["Yms_BookingTasks"] = retLookupList;
                                return prev;
                            });
                        }
                    }
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        }
        getDefaultLayouts();
    }, [serverUrl, props.userToken, allColumnsObj]);

    useEffect(() => {
        async function getYmsBooking() {
            if (!bookingId) return;
            const objectName = "Yms_Booking";
            if (Object.keys(allColumnsObj).length === 0) return;
            let defaultVariables = {
                "instanceName": "m_yms_booking",
                "filterName": "customfilter",
                "dontCash": "true"
            }
            let prms = [];
            let prmValues = {};
            if (actions === "EditBoocking") {
                defaultVariables["appendFilter"] = "{BookingId} =?(;n;15;p_BookingId) ";
                prms.push({ "parameterName": "p_BookingId", "type": "" });
                prmValues["p_BookingId"] = Number(bookingId || 0);
            }
            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
            if (result.data[objectName]) {
                let resultobj = result.data[objectName];

                let objEdit = {
                    Obj: resultobj[0],
                    rowRestrictions: result.rowRestrictions,
                    disabledFields: result.disabledFields
                }
                const resYmsBsu = await getBookingSuppliers(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsBsu) {
                    objEdit["Yms_BookingSuppliers"] = resYmsBsu;
                }
                const resYmsPor = await getPorders(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsPor) {
                    objEdit["Yms_Porders"] = resYmsPor;
                }
                const YmsBta = await getBookingTasks(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (YmsBta) {
                    objEdit["Yms_BookingTasks"] = YmsBta;
                }
                setBookingObj(objEdit)
            }
        }
        getYmsBooking();
    }, [allColumnsObj, props.setBookingId, serverUrl, userid, props.supplierData, props.warehouseid, actions, props.selectTtimeSlot, app.sessionToken, props.userToken, bookingId]);

    const fetchLicenseNo = async (LicenseNo) => {
        if (!LicenseNo || Object.keys(allColumnsObj).length === 0) return;

        const objectName = "Yms_Booking";
        const today = format(new Date(), 'yyyy-MM-dd');

        const prms = [
            { parameterName: "p_LicenseNo", type: "" },
            { parameterName: "p_TodayDate", type: "" },
            { parameterName: "p_WarehouseId", type: "" }
        ];

        const prmValues = {
            p_LicenseNo: LicenseNo,
            p_TodayDate: today,
            p_WarehouseId: app.sessionToken.WarehouseId
        };

        const defaultVariables = {
            filterName: "customfilter",
            appendFilter: `
                YmsTrk1.LicenseNo = ?(;s;12;p_LicenseNo)
                AND {YmsBok.WarehouseId} = ?(;n;5;p_WarehouseId)
                AND (
                    (
                        TRUNC(FromDate) = TO_DATE(?(;s;10;p_TodayDate), 'YYYY-MM-DD')
                        AND Status IN (5,6)
                    )
                    OR
                    (
                        TRUNC(FromDate) BETWEEN 
                            ADD_MONTHS(TO_DATE(?(;s;10;p_TodayDate), 'YYYY-MM-DD'), -1)
                            AND TO_DATE(?(;s;10;p_TodayDate), 'YYYY-MM-DD')
                        AND Status = 7
                        AND EXISTS (
                            SELECT 1
                            FROM Yms_BookingTasks BT
                            WHERE BT.BookingId = {BookingId}
                            AND BT.Status > 2
                        )
                    )
                )
            `
        };

        setShowMatchingDropdown(false);
        setShowNoResultsMessage(false);

        try {
            const responseObj = await loadDataObject(
                serverUrl,
                props.userToken,
                objectName,
                allColumnsObj,
                prms,
                prmValues,
                defaultVariables
            );

            if (responseObj && responseObj.length > 0) {
                if (responseObj.length === 1) {
                    setBookingId(responseObj[0].BookingId);
                    setActions("EditBoocking");
                    setDisabledFieldsFlg(true);
                    setLicenseNo(responseObj);
                    setShowMatchingDropdown(false);
                } else {
                    setLicenseNo(responseObj);
                    setShowMatchingDropdown(true);
                }
            } else {
                setLicenseNo([]);
                setShowNoResultsMessage(true);
                setTimeout(() => setShowNoResultsMessage(false), 6000);
            }
        } catch (error) {
            setLicenseNo([]);
            setShowNoResultsMessage(true);
            setTimeout(() => setShowNoResultsMessage(false), 6000);
        }
    };

    async function addTask() {
        const objectName = "Yms_BookingTasks";
        let prms = [];
        let prmValues = {};
        const parentSelectedRow = bookingObj.Obj;
        let defaultVariables = {
            "instanceName": "m_yms_booking",
            "dontCash": "true"
        }
        defaultVariables["createNewRow"] = "true";
        defaultVariables["parentSelectedRow"] = parentSelectedRow;
        const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
        if (result.data[objectName]) {

            setBookingObj(prev => {
                prev = { ...prev }
                if (!prev[objectName]) prev[objectName] = [];
                else prev[objectName] = [...prev[objectName]];
                prev[objectName].push(result.data[objectName][0]);
                return prev;
            });
        }
    };
    const deleteTask = (rowIndex) => {
        let tmpbookingObj = { ...bookingObj }
        tmpbookingObj["Yms_BookingTasks"].splice(rowIndex, 1)
        setBookingObj(tmpbookingObj);
    };
    async function handleSaveBooking(e) {
        if (actions !== "EditBoocking") return setError(t('tablet.noBookingSelected', language));
        e?.preventDefault();
        setError(null);
        try {
            const finalPaths = await photoUploadRef.current?.applyPendingChanges();
            let tmpbookingObj = { ...bookingObj };
            if (!tmpbookingObj["Obj"]) tmpbookingObj["Obj"] = {};
            tmpbookingObj["Obj"].PhotoPath = finalPaths;
            tmpbookingObj["Obj"].Status = 8;
            setBookingObj(tmpbookingObj);

            const saveobj = await postBooking(serverUrl, props.userToken, "Yms_Booking", "m_yms_booking", tmpbookingObj);
            if (saveobj) {
                setShowModal(true);
                setTimeout(() => {
                    window.location.href = '/tablet-view';
                }, 1700);
            }
        } catch (err) {
            setError(err.message);
        }
    }
    handleSaveBookingRef.current = handleSaveBooking;

    function handleCloseModalSuccessMes(e) {
        e?.preventDefault?.();
        setShowModal(false);
    }
    async function setObjectValue(objName, rowIndex, column, value, selectedIndex) {
        let obj = {};

        if (rowIndex === null) {
            obj = { ...bookingObj["Obj"] };
        } else {
            obj = { ...bookingObj[objName][rowIndex] };
        }
        let tmpObj = { ...obj };
        setPropValue(tmpObj, column.columnName, value);

        if (column.columnName === "FromDate") {
            tmpObj["InDate"] = value;
        }

        if (selectedIndex >= 0 && lookUpInfo[objName][column.columnName] && lookUpInfo[objName][column.columnName].keyFields) {
            for (let i = 0; i < lookUpInfo[objName][column.columnName].keyFields.length; i++) {
                let kf = lookUpInfo[objName][column.columnName].keyFields[i];
                if (selectedIndex === 0) {
                    tmpObj[kf.foreignField] = null;
                }
                else {
                    tmpObj[kf.foreignField] = lookUpInfo[objName][column.columnName].values[selectedIndex - 1][kf.primaryField];
                }
            };
        }
        let tmpbookingObj = { ...bookingObj }

        if (rowIndex === null) {
            tmpbookingObj["Obj"] = tmpObj;
        }
        else {
            tmpbookingObj[objName][rowIndex] = tmpObj;
        }
        if (column.columnName === "StampFlg") {
            tmpbookingObj["Obj"].StampFlg = value ? 1 : 0;
        }
        if (column.columnName === "YmsDri1.Name1") {
            tmpbookingObj["Obj"].YmsDri1.DriverCode = value.secondaryField;
            tmpbookingObj["Obj"].DriverId = value.pkField;
            tmpbookingObj["Obj"].YmsDri1.Name1 = value.lkpField;
        }
        if (column.columnName === "YmsTrk1.LicenseNo") {
            tmpbookingObj["Obj"].YmsTrk1.LicenseNo = value.lkpField;
            tmpbookingObj["Obj"].TruckId = value.pkField;
            tmpbookingObj["Obj"].YmsTrk1.Descr1 = value.secondaryField;
        }
        setBookingObj(tmpbookingObj);
    }

    function createTextBox(obj, columnName, objName, rowIndex, disabledFieldsFlg) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        let colValue = getPropValue(obj, column.columnName)
        return <Form.Control
            value={colValue}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.value)}
            readOnly={column.editNotAllowed === true}
            disabled={disabledFieldsFlg}
        />;

    }
    function createTextBoxCommends(obj, columnName, objName, rowIndex) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        let colValue = getPropValue(obj, column.columnName)
        return <Form.Control
            as="textarea"
            rows={6}
            value={colValue}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.value)}
            readOnly={column.editNotAllowed === true}

        />;

    }
    function createDropDownLookUpList(obj, columnName, objName, rowIndex, disabledFieldsFlg) {
        if (!lookUpInfo[objName] || !lookUpInfo[objName][columnName]) return null;
        let column = lookUpInfo[objName][columnName].column;

        const options = lookUpInfo[objName][column.columnName].values.map(lkpObj => ({
            value: lkpObj[column.dropDownDisplay],
            label: lkpObj[column.dropDownDisplay]
        }));

        return (
            <CustomDropdown
                options={options}
                value={getPropValue(obj, column.columnName)}
                onChange={e => setObjectValue(objName, rowIndex, column, e.target.value, e.target.selectedIndex)}
                readonly={column.editNotAllowed === true}
                disabled={disabledFieldsFlg}
                showEmptyOption={true}
                placeholder="Επιλέξτε..."
            />
        );
    }
    function createAutoCompleteGeneric({
        objName,
        rowIndex,
        disabledFieldsFlg,
        columnConfig,
        objectName,
        instanceName,
        lookupPrimaryField,
        lookupSecondaryField,
        setFieldsInBookingObj
    }) {
        const obj = rowIndex === null
            ? bookingObj["Obj"]
            : bookingObj[objName][rowIndex];

        const primaryVal = getPropValue(obj, columnConfig.columnName) || "";
        const secondaryVal = getPropValue(obj, columnConfig.secondaryField) || "";

        return (
            <AutoCompleteOneOutPut
                key={`${primaryVal}_${secondaryVal}`}
                as="AutoComplete"
                placeholder=""
                serverUrl={serverUrl}
                props={props}
                col={columnConfig}
                obj={{
                    ...obj,
                    [columnConfig.columnName]: primaryVal,
                    [columnConfig.secondaryField]: secondaryVal,
                }}
                onChange={async (e) => {
                    if (e && e?.option?.secondaryField === '') {
                        let prms = [];
                        let prmValues = {};
                        const parentSelectedRow = bookingObj.Obj;
                        let defaultVariables = {
                            instanceName: instanceName,
                            dontCash: "true",
                            createNewRow: "true",
                            parentSelectedRow: parentSelectedRow
                        };

                        const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables);
                        const rawData = result?.data?.[objectName]?.[0] || {};
                        let tmprawData = { ...rawData };
                        if (columnConfig.columnName === 'YmsDri1.Name1') {
                            tmprawData[lookupPrimaryField] = e?.option.lkpField;
                            tmprawData.ActiveFlg = true;
                            tmprawData[lookupSecondaryField] = tmprawData.DriverId;
                        } else {
                            tmprawData[lookupPrimaryField] = e?.option.lkpField;
                            tmprawData.ActiveFlg = true;
                            tmprawData[lookupSecondaryField] = `Εκκρεμής ${columnConfig.descr}`;
                        }


                        const gqlCols = createGql("", allColumnsObj[objectName].columns, []);
                        const requestBody = {
                            query: `mutation save${objectName}($obj: ${objectName}!){` +
                                `save${objectName}(${objectName}: $obj) ${gqlCols.query} }`,
                            variables: {
                                obj: {
                                    instanceName: '',
                                    filterName: "default",
                                    top: gridTop,
                                    changedData: [
                                        {
                                            action: "insert",
                                            original: null,
                                            current: tmprawData
                                        }
                                    ]
                                }
                            }
                        };
                        const gqlResult = await callApi('POST', `${serverUrl}/api/query`, props.userToken, requestBody);
                        const newEntry = gqlResult.data[objectName][0];

                        let tmpbookingObj = { ...bookingObj };
                        setFieldsInBookingObj(tmpbookingObj, newEntry);
                        setBookingObj(tmpbookingObj);
                        return;
                    }

                    setObjectValue(objName, rowIndex, columnConfig, e ? e.option : "");
                    if (columnConfig.columnName === "YmsTrk1.LicenseNo" && e?.option?.lkpField) {
                        fetchLicenseNo(e.option.lkpField);
                        setShowMatchingDropdown(true);
                    }
                }}
                disabled={disabledFieldsFlg}
            />
        );
    }
    const statusMap = {
        null: {
            text: t("StatusDescr.default", language),
            bg: "#F5F5F5",
            color: "#333"
        },
        1: {
            text: t("profileMenu.statusItems.readyToLoad", language),
            bg: "#F5FFE8",
            color: "#8CF553"
        },
        2: {
            text: t("profileMenu.statusItems.loading", language),
            bg: "#E8F5FF",
            color: "#14AE5C"
        },
        3: {
            text: t("StatusDescr.finished", language),
            bg: "#F0F0F0",
            color: "#8D97B0"
        }
    };

    if (isLoading) return <Loading />;
    if (!isLoadObj) return;
    return (
        <div>
            <ErrorAlert message={error} setMessage={setError} language={language} />
            {showModal && (
                <div className="modal-container-tablet">
                    <div className="modal-content-container-tablet">
                        <button onClick={handleCloseModalSuccessMes} className='close-btn-modal-tablet'>
                            <i className="bi bi-x-lg"></i>
                        </button>

                        <TabletSuccMessage
                            title={titleValue}
                            paragraph={
                                <>
                                    {getPropValue(bookingObj.Obj, "ArrivalId") && (
                                        <>
                                            {t("ModalBooking.codeForEntry", language)}: <strong>{getPropValue(bookingObj.Obj, "ArrivalId")}</strong>
                                        </>
                                    )}
                                </>
                            }
                            btnSuccessScreen={btnSuccessScreenValue}
                        />


                    </div>
                </div>
            )}
            <>
                <Form>
                    <Row className="mb-3">
                        <Col md={9}>
                            <Form.Group>
                                <Form.Label>{t("ModalBooking.licenseNoTitleForm", language)} <span className='required-bullet'>*</span></Form.Label>
                                {createAutoCompleteGeneric({
                                    objName: "Yms_Booking",
                                    rowIndex: null,
                                    disabledFieldsFlg: disabledFieldsFlg,
                                    columnConfig: {
                                        descr: "πινακίδα",
                                        columnName: "YmsTrk1.LicenseNo",
                                        dropDownDisplay: "LicenseNo",
                                        lookUpQuery: "{Yms_Trucks{TruckId LicenseNo Descr1}}",
                                        secondaryField: "YmsTrk1.Descr1"
                                    },
                                    objectName: "Yms_Trucks",
                                    instanceName: "m_yms_trucks",
                                    lookupPrimaryField: "LicenseNo",
                                    lookupSecondaryField: "Descr1",
                                    setFieldsInBookingObj: (tmpObj, newEntry) => {
                                        tmpObj["Obj"].YmsTrk1.LicenseNo = newEntry.LicenseNo;
                                        tmpObj["Obj"].TruckId = newEntry.TruckId;
                                        tmpObj["Obj"].YmsTrk1.Descr1 = newEntry.Descr1;
                                    }
                                })}
                            </Form.Group>
                        </Col>
                        <Col md={3} className="d-flex align-items-end">
                            <button type="button" className="btn btn-tablet-color w-100 mb-2" disabled>
                                <i className="bi bi-upc-scan"></i> {t("entryWithBooking.scanButton", language)}
                            </button>
                        </Col>
                    </Row>
                    {showNoResultsMessage && (
                        <div className="yard-alert">
                            <WarningIcon style={{ marginRight: "5px" }} /> {t("exitBooking.warningWithBookingAndVat", language)}
                        </div>
                    )}
                    {licenseNo.length > 0 && showMatchingDropdown && (
                        <>
                            <div className="mt-2 mb-2 border rounded p-2" style={{ backgroundColor: app.theme === 'dark' ? '#3a3d40' : '#f8f9fa' }}>
                                <h5 style={{ color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}> {t("entryWithBooking.availableBookings", language)}</h5>
                                {paginationLicenseNo.map((item, idx) => (
                                    <div
                                        key={idx}
                                        onClick={() => {
                                            setBookingId(item?.BookingId);;
                                            setActions("EditBoocking");
                                            setShowMatchingDropdown(false);
                                            setDisabledFieldsFlg(true);
                                        }}
                                        className="p-2 mb-1 rounded border shadow-sm"
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: app.theme === 'dark' ? 'var(--bg-tertiary)' : '#fff',
                                            color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit',
                                            borderColor: app.theme === 'dark' ? '#495057' : '#dee2e6'
                                        }}
                                    >
                                        <div><strong>{t("entryWithBooking.warehouse", language)}:</strong> {item?.YmsWrh1.Descr1}</div>
                                        <div><strong>{t("entryWithBooking.bookingId", language)}:</strong> {item?.BookingId}</div>
                                        {item?.ArrivalId && <div><strong>Arrival ID:</strong> {item.ArrivalId}</div>}
                                        <div><strong>{t("ModalBooking.supplierTitleForm", language)}:</strong> {item?.SupDescr}</div>
                                        <div><strong>{t("ModalBooking.licenseNoTitleForm", language)}:</strong> {item?.YmsTrk1.LicenseNo}</div>
                                        <div><strong>{t("ModalBooking.driverTitleForm", language)}:</strong> {item?.YmsDri1.Name1}</div>
                                    </div>
                                ))}
                            </div>
                            <PaginationControls
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={(newPage) => setCurrentPage(newPage)}
                            /></>
                    )}
                    <Form.Group className="mb-3">
                        <Form.Label>{t("ModalBooking.driverTitleForm", language)}</Form.Label>
                        {createAutoCompleteGeneric({
                            objName: "Yms_Booking",
                            rowIndex: null,
                            disabledFieldsFlg: props.disabledFieldsFlg,
                            columnConfig: {
                                descr: "οδηγό",
                                columnName: "YmsDri1.Name1",
                                dropDownDisplay: "Name1",
                                lookUpQuery: "{Yms_Drivers{DriverId Name1 DriverCode}}",
                                secondaryField: "YmsDri1.DriverCode"
                            },
                            objectName: "Yms_Drivers",
                            instanceName: "m_yms_drivers",
                            lookupPrimaryField: "Name1",
                            lookupSecondaryField: "DriverCode",
                            setFieldsInBookingObj: (tmpObj, newEntry) => {
                                tmpObj["Obj"].YmsDri1.Name1 = newEntry.Name1;
                                tmpObj["Obj"].DriverId = newEntry.DriverId;
                                tmpObj["Obj"].YmsDri1.DriverCode = newEntry.DriverCode;
                            }
                        })
                        }
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("ModalBooking.phoneTitleForm", language)}</Form.Label>
                        {createTextBox(bookingObj.Obj, "Phone", "Yms_Booking", null)}
                    </Form.Group>
                </Form>
                {warningMessage &&
                    <div className="status-warning">
                        <WarningIcon style={{ marginRight: "5px" }} /> {warningMessage}
                    </div>
                }
                <div className="header-form-exit-booking" style={{ marginTop: "10px" }}>
                    <div className="button-toggle-tasks" onClick={() => setShowTasks(!showTasks)}>
                        <span><i className={`bi ${showTasks ? 'bi-chevron-up' : 'bi-chevron-down'} me-2`}></i> {t("ModalBooking.actionsHeader", language)}</span>
                        {bookingObj["Yms_BookingTasks"]?.length > 0 && <span className="total-task-label">{bookingObj["Yms_BookingTasks"]?.length === 1 ? t("ModalBooking.taskLabel", language) : t("ModalBooking.actionsHeader", language)} ({bookingObj["Yms_BookingTasks"]?.length})</span>}
                    </div>
                    <div>
                        {showTasks && (
                            <>
                                <div className="tasks-container">
                                    {bookingObj["Yms_BookingTasks"]?.length > 0 ? (
                                        bookingObj["Yms_BookingTasks"].map((task, index) => {
                                            const statusKey = task.Status === null || task.Status === undefined ? "null" : task.Status;
                                            const { text: statusText, bg: bgColor, color: statusColor } = statusMap[statusKey] || statusMap[null];
                                            const statusNumber = Number(statusKey);
                                            const showCompleteBtn = isNaN(statusNumber) || statusNumber < 3;
                                            return (
                                                <div className="task-item" key={task.BookingTaskId || index}>
                                                    <div className="task-header d-flex justify-content-between align-items-start flex-wrap">
                                                        <span className="task-title">
                                                            <strong>{t("ModalBooking.taskLabel", language)}:</strong>{" "}
                                                            {task.YmsTas1?.Descr1 || t("ModalBooking.newTaskLabel", language)}
                                                        </span>

                                                        <div className="d-flex align-items-center gap-2 mt-md-0 position-relative">
                                                            <span
                                                                style={{ marginRight: "35px" }}
                                                                className={`event-status-badge`}
                                                            >
                                                                {/* {console.log("statusNumber", statusNumber)} */}
                                                                <span
                                                                    style={{
                                                                        background: bgColor,
                                                                        color: statusColor,
                                                                        padding: "4px 10px",
                                                                        borderRadius: "22px",
                                                                        fontSize: "15px",
                                                                        fontWeight: "500",
                                                                        textTransform: "capitalize",
                                                                    }}
                                                                >
                                                                    <span className="event-status-dot" style={{ backgroundColor: statusColor }} />&nbsp;
                                                                    {statusText}
                                                                </span>
                                                            </span>

                                                            {showCompleteBtn && (
                                                                <button
                                                                    type="button"
                                                                    className="complete-task-btn"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        let tmpbookingObj = { ...bookingObj };
                                                                        tmpbookingObj["Yms_BookingTasks"] = [...tmpbookingObj["Yms_BookingTasks"]];
                                                                        tmpbookingObj["Yms_BookingTasks"][index] = {
                                                                            ...tmpbookingObj["Yms_BookingTasks"][index],
                                                                            Status: 3,
                                                                        };
                                                                        setBookingObj(tmpbookingObj);
                                                                        // console.log("πατηθηκε");
                                                                    }}
                                                                >
                                                                    <i className="bi bi-check-circle"></i>
                                                                </button>
                                                            )}

                                                            {!disabledFieldsFlg && (
                                                                <span
                                                                    className="delete-icon"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        deleteTask(index);
                                                                    }}
                                                                >
                                                                    <i className="bi bi-ban"></i>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <Form className="mb-3">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                {t("ModalBooking.taskLabel", language)} <span className="required-bullet">*</span>
                                                            </Form.Label>
                                                            {createDropDownLookUpList(task, "YmsTas1.Descr1", "Yms_BookingTasks", index, disabledFieldsFlg)}
                                                        </Form.Group>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="label-to-left"> {t("ModalBooking.itemCountTitleForm", language)} </Form.Label>
                                                            {createTextBox(task, "CountOfItems", "Yms_BookingTasks", index, disabledFieldsFlg)}
                                                        </Form.Group>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="label-to-left"> {t("ModalBooking.palletCountTitleForm", language)} </Form.Label>
                                                            {createTextBox(task, "Pallets", "Yms_BookingTasks", index, disabledFieldsFlg)}
                                                        </Form.Group>
                                                    </Form>
                                                    <hr />
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <p className="text-muted">{t("calendarEvent.noActionsAdded", language)}</p>
                                    )}

                                    {(!disabledFieldsFlg || actions !== "EditBoocking") && <Button className="button-add-task" onClick={addTask}>
                                        <i className="bi bi-plus-circle"></i>  {t("ModalBooking.addTaskButton", language)}
                                    </Button>}
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <Form.Group className="mb-3">
                    <Form.Label>{t("entryWithBooking.commentTitleForm", language)}</Form.Label>
                    {createTextBoxCommends(bookingObj.Obj, "Notes", "Yms_Booking", null)}
                </Form.Group>
                <PhotoUpload
                    ref={photoUploadRef}
                    photoUrl={getPropValue(bookingObj.Obj, "PhotoPath")}
                    onImagesChange={handleImagesChange}
                    language={language}
                    serverUrl={serverUrl}
                    userToken={props.userToken}
                />
            </>

        </div >
    );
}

export default EditBookingForm;
